export interface IVendorPanelDescRequest{
  region: string[];
  country: string[];
  userRole: string;
}
